<template>
  <div class="user-vip-remark flex-col aic">
    <div class="header w100">
      <div class="g-center por h100">
        <div class="inner abs-m flex-col aic lh1 bsb" :class="{'is-vip': userInfo.is_web_vip}">
          <img :src="userInfo.icon + ''" v-df-avatar alt="" class="user-avatar vam">
          <div class="real-name" @click="userInfo.uid || ToLogin()" :class="{csp: !userInfo.uid}">{{userInfo.uid ?
            userInfo.realname || userInfo.nickname || ('用户' + userInfo.username) : '立即登录'}}
          </div>
          <template v-if="userInfo.uid">
            <div class="user-detail">
              <span>账号ID: {{userInfo.username}}</span>
              <span v-show="userInfo.phone">（{{userInfo.phone}}）</span>
            </div>
            <div class="vip-list bsb flex-col jcc wsnw">
              <template v-if="myVipList.length">
                <div class="vip-item" v-for="(item, i) in myVipList" :key="i"><i class="curr-ico vip vat"></i>{{item.name}}
                </div>
              </template>
              <div class="vip-item tac" v-else>您还不是会员</div>
            </div>
          </template>
          <div class="user-remark-list flex fww" v-else>
            <div class="user-remark w50 flex aic" v-for="(item, i) in userBoxRemark" :key="i">
              <i class="curr-ico img" :class="item.ico"></i>
              <div class="user-remark-text wsnw">
                <div class="title">{{item.title}}</div>
                <div class="subtitle">{{item.subtitle}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img src="../../assets/images/vip/text_icon1.png" alt="" class="img-title vat"/>
    <div class="content-inner flex aic">
      <div class="vip-card lh1 tac por" :class="[vip.type, {active: currType === vip.type}]"
           v-for="(vip, i) in vipCards"
           :key="i">
        <div class="name">{{vip.name}}</div>
        <div class="subtitle">{{vip.subtitle}}</div>
        <div class="to-pay mlr-auto csp" @click="ShowVip({dfSelect: vip.type})">立即购买</div>
        <div class="list aic">
          <div class="list-item" v-for="(item, j) in vip.list" :key="j">{{item}}</div>
        </div>
        <img src="../../assets/images/vip/tj_left.png" alt="" class="recommend poa t0 vat l0 dn">
      </div>
    </div>
    <img src="../../assets/images/vip/text_icon2.png" alt="" class="img-title vat"/>
    <div class="remark">
      <mine-remark class="mine-remark"></mine-remark>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "UserRemark",
    computed: {
      ...mapGetters(['userInfo', 'allGrades']),
      currType() {
        return this.allGrades && this.allGrades.find(e => +e.pid === 2 && e.id === +this.userInfo.nianji_id) ? 'tb' : 'gl';
      },
    },
    data() {
      return {
        userBoxRemark: [
          {ico: 'know', title: '同步知识学习', subtitle: '预复习快人一步'},
          {ico: 'press', title: '教材同步学', subtitle: '多版本教材学习'},
          {ico: 'more-know', title: '精彩课程及时看', subtitle: '拓展知识库'},
          {ico: 'gift', title: '好礼限时领', subtitle: '惊喜活动等你来'},
        ],
        myVipList: [],
        vipCards: [
          {
            type: 'tb',
            name: '同步小学课堂VIP会员',
            subtitle: '小学1-6年级VIP课程任意学',
            list: [
              '可用学段：小学',
              '畅享1-6年级 VIP课程',
              '语文、数学、英语、科学均可免费观看',
              '会员期间 支持无限次回看',
              '1-6年级素质拓展VIP课任意看',
              '支持手机、平板、电视、电脑端同时观看',
            ]
          },
          {
            type: 'gl',
            name: '格灵课堂VIP会员',
            subtitle: '畅享全站VIP课程',
            list: [
              '可用学段：学龄前、小学、初中、高中',
              '畅享全站100000+VIP课程',
              '九大学科VIP课程均可免费观看',
              '会员期间 支持无限次回看',
              '全站素质拓展VIP课程任意看',
              '支持手机、平板、电视、电脑端同时观看',
            ]
          },
        ],
      };
    },
    created() {
      this.getMyVip();
    },
    methods: {
      getMyVip() {
        this.http.NEWMyVip({
          uid: this.userInfo.uid,
          limits: 1000
        }).then(res => {
          this.myVipList = res.list;
        }).catch(console.log);
      },
    },
  }
</script>

<style scoped lang="less">
  @import "../../assets/less/function";

  .curr-ico {
    &:not(.img) {
      .spirit-mask(url(../../assets/images/vip_icon.png));
    }
    &.img {
      .spirit(url(../../assets/images/vip_icon.png));
      &:after {
        margin-right: 13px;
        width: 32px;
        height: 32px;
      }
    }

    &.vip {
      &:after {
        width: 17px;
        height: 15px;
        mask-position: -159px -1px;
        background-color: rgba(255, 255, 255, .2);
      }
    }
    &.know {
      &:after {
        background-position: -2px -1px;
      }
    }
    &.press {
      &:after {
        background-position: -36px -1px;
      }
    }
    &.more-know {
      &:after {
        background-position: -70px -1px;
      }
    }
    &.gift {
      &:after {
        background-position: -104px -1px;
      }
    }
  }

  .user-vip-remark {
    background-color: #f5fcff;
  }

  .header {
    margin-bottom: 63px;
    height: 300px;
    background: url(../../assets/images/vip/header_bg.png) no-repeat center center / auto 100%;
    font-size: 14px;
    color: #fff;
    .inner {
      right: 30px;
      padding-top: 18px;
      width: 368px;
      height: 240px;
      background: url(../../assets/images/vip/user_icon1.png) no-repeat top left / 100% 100%;
    }
    .user-avatar {
      margin-bottom: 15px;
      width: 48px;
      height: 48px;
      border-radius: 48px;
    }
    .real-name {
      margin-bottom: 16px;
      &.csp {
        &:hover {
          color: #ffd99e;
        }
      }
    }
    .user-detail {
      margin-bottom: 16px;
      font-size: 12px;
      opacity: .5;
    }
    .vip-list {
      padding: 8px 82px;
      width: 304px;
      height: 84px;
      background-color: rgba(0, 15, 34, .3);
      border-radius: 6px;
    }
    .vip-item {
      margin-top: 10px;
      font-size: 12px;
      // color: rgba(255, 255, 255, .2);
      line-height: 16px;
      color: #ffd99e;
      .vip {
        margin-right: 8px;
        line-height: 0;
        &:after {
          background-color: #ffd99e;
        }
      }
      &:first-child {
        margin-top: 0;
      }
      &:nth-child(n + 4) {
        display: none;
      }
    }
    .is-vip {
      background-image: url(../../assets/images/vip/user_icon2.png);
      .vip-list {
        background-color: #735b48;
      }
      .real-name {
        color: #795a2f;
        font-weight: bold;
      }
      .user-detail {
        color: rgba(56, 35, 14, .8);
        opacity: 1;
      }
    }

    .user-remark-list {
      margin-top: -8px;
      font-size: 14px;
      .user-remark {
        margin-top: 24px;
        padding-left: 26px;
      }
      .subtitle {
        margin-top: 6px;
        font-size: 12px;
        color: rgba(255, 255, 255, .5);
      }
    }
  }

  .img-title {
    margin-bottom: 56px;
  }

  .content-inner {
    margin-bottom: 100px;
    font-size: 16px;
    color: #333f4e;
    .vip-card {
      padding-top: 39px;
      width: 480px;
      background-color: #fff;
      border-radius: 8px;
    }
    .gl {
      .recommend {
        left: unset;
        right: 0;
        transform: rotateZ(90deg);
      }
    }
    .name {
      margin-bottom: 19px;
      font-size: 30px;
    }
    .subtitle {
      margin-bottom: 31px;
      font-size: 18px;
    }
    .to-pay {
      margin-bottom: 34px;
      width: 160px;
      font-size: 18px;
      line-height: 40px;
      color: #b9732e;
      background: linear-gradient(98deg, #FFD99E, #FFD28C);
      border-radius: 40px;
      &:hover {
        background: #fdcc81;
      }
    }
    .list {
      line-height: 60px;
      > :nth-child(2n + 1) {
        background-color: #f5f7fb;
      }
    }
    .active {
      padding-top: 52px;
      width: 500px;
      background-color: #fff8ee;
      box-shadow: 0 4px 8px 0 rgba(0, 15, 34, .08);
      .name {
        color: #b9732e;
        font-weight: bold;
      }
      .list {
        > :nth-child(2n + 1) {
          background-color: #fff3e0;
        }
      }
      .recommend {
        display: block;
      }
    }
  }

  .remark {
    width: 848px;
    .mine-remark {
      margin-bottom: 100px;
    }
  }
</style>